<form
  class="ivr-container"
  [formGroup]="ivrForm"
  ccScrollToFirstInvalidField
>
  <cc-box>

    <div class="container-responsive" header box>
      {{ (isCreatingNewIvr ? 'IVR.ADD_IVR_TITLE' : 'IVR.EDIT_IVR_TITLE') | translate }}
    </div>
    <div class="ivr-row" content box>
      <label>
        {{ 'IVR.NAME' | translate }}
      </label>

      <div class="input-error input-name-wrapper">
        <input name="name" formControlName="name" class="input form-control" required placeholder="{{ 'IVR.NAME' | translate }}"/>
        <cc-input-errors
          [form]="ivrForm"
          inputName="name"
          [errors]="[{'required': 'IVR.ENTER_THE_NAME'}]"
        ></cc-input-errors>
      </div>

    </div>
    <div
      class="ivr-row border-row"
      content
      box
    >
      <span translate class="welcome-message-label">IVR.WELCOME_MESSAGE_BEFORE_IVR</span>
      <ui-switch class="pull-right custom"
                 formControlName="msisdnWelcomeMessageEnabled"></ui-switch>
    </div>

    <div class="ivr-row border-row" content box>
      <label class="add-new-file-label" translate>IVR.ADD_NEW_FILE</label>
      <div class="add-new-file-wrapper">
        <cc-file-drop
          *ngIf="!greetingFileId && !greetingFileName"
          [class.file-required-error-border]="shouldShowFileError"
          [class.ng-invalid]="shouldShowFileError"
          [url]="'/ivr/greeting'"
          [type]="'mp3'"
          [method]="'POST'"
          (refresh)="onFileUploaded($event)"
        ></cc-file-drop>
        <cc-file-drop-player
          *ngIf="greetingFileId || greetingFileName"
          [voiceMailFileName]="temporaryFileName || greetingFileName"
          [url]="greetingFileName ? '/ivr/menu/' + ivr.menus[0].id +  '/greeting' : '/ivr/greeting/' + greetingFileId"
          (remove)="onFileRemove()"
        ></cc-file-drop-player>

        <div class="file-required-error" *ngIf="shouldShowFileError">
          {{ 'ERRORS.REQUIRED_FILE' | translate }}
        </div>
      </div>
    </div>
    <div
      class="ivr-row ivr-row-keypad "
      content
      box
    >
      <cc-keypad
        [class.keypad-required-error-border]="shouldShowKeypadError"
        [class.ng-invalid]="shouldShowKeypadError"
        [selectedKeys]="selectedKeys"
        (characterClick)="onCharacterClicked($event)"
      ></cc-keypad>
      <div class="keypad-required-error" *ngIf="shouldShowKeypadError">
        {{ 'IVR.ANY_KEY_REQUIRED' | translate }}
      </div>

      <div class="info-wrapper">
        <p class="info-content">{{ 'IVR.INFO_ZERO' | translate }}</p>
      </div>

      <cc-ivr-actions
        class="ivr-actions"
        [configuration]="ivr"
        [msisdns]="allAvailableMsisdns"
        [ivrActionsFormWrapper]="ivrForm"
        (removeIvrAction)="removeIvrItem($event)"
      ></cc-ivr-actions>
    </div>
    <div content box formArrayName="menus" class="force-no-top-border">
      <div formGroupName="0" class="ivr-row no-top-border">
        <label class="ivr-config-label" translate>IVR.INTERVAL_BREAK_TIME</label>
        <span class="ivr-config-suffix" translate>SECONDS</span>
        <div class="ivr-config-input input-error">
          <input class="input ivr-config-input" formControlName="interGreetingPauseSecs" type="number" min="0"
                 step="5"/>
          <cc-input-errors
            [form]="ivrForm"
            [inputName]="'menus.0.interGreetingPauseSecs'"
            [errors]="[{'required': 'ERRORS.REQUIRED'}, {'min': 'LEAD_GENERATION.MIN_VALUE' | translate:{ value: 0 } }]"
          ></cc-input-errors>
        </div>
      </div>
      <div formGroupName="0" class="ivr-row" content box>
        <label class="ivr-config-label" translate>IVR.DISCONNECT_USER_AFTER_ITERATIONS</label>
        <span class="ivr-config-suffix" translate>IVR.TIMES</span>
        <div class="ivr-config-input input-error">
          <input class="input ivr-config-input" formControlName="greetingIterationsCount" type="number" min="0"/>
          <cc-input-errors
            [form]="ivrForm"
            [inputName]="'menus.0.greetingIterationsCount'"
            [errors]="[{'required': 'ERRORS.REQUIRED'}, {'min': 'LEAD_GENERATION.MIN_VALUE' | translate:{ value: 0 } }]"
          ></cc-input-errors>
        </div>
      </div>
    </div>

    <div content box class="force-no-border"
         *ngxPermissionsOnly="'WORKING_HOURS_PERMISSION'"
    >
    <cc-lg-working-hours-list
      class="force-no-border"
      [configuration]="ivr"
      [workingHoursFormWrapper]="workingHoursFormWrapper"
      displayTitle="IVR.USE_DURING"
    ></cc-lg-working-hours-list>
    </div>

    <div content box class="ivr-row" *ngIf="assignedMsisdns.length">
      <div header box>
        <label class="ivr-config-label">{{ 'IVR.ASSIGNED_NUMBERS' | translate }}</label>
      </div>

      <div class="container-responsive" content box>
        <div class="projects-row">
          <ul class="list-group list">
            <li
              *ngFor="let msisdn of assignedMsisdns"
              class="list-group-item"
            >
              <cc-msisdn [msisdn]="msisdn"></cc-msisdn>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="button-wrapper" content box>
      <button
        mat-raised-button
        color="info-full"
        routerLink="/ivr"
        class="cancel-button"
      >
        {{'CANCEL' | translate}}
      </button>
      <button
        mat-raised-button
        color="primary-full"
        (click)="onSubmit()"
      >
        {{'SAVE' | translate}}
      </button>
    </div>

  </cc-box>

</form>
